import { motion } from "framer-motion";
import { Building2, MapPin, Quote, ArrowUpRight, Radio } from "lucide-react";

const CASCADE_POOL = "/marketing/cascade-pool.webp";

/* PROOF, the live customer (Cascade Condominiums, Goodwin & Company) + the study, right under the hero.
   Only owner-supplied facts appear here. Story copy and quote are marked as slots until the owner supplies them. */

export function ProofBar() {
  return (
    <section className="rm-proofbar" data-testid="concept-proof-bar" aria-label="Proof">
      <div className="rm-container rm-proofbar-grid">
        <div className="rm-proofbar-live" data-testid="concept-proof-live">
          <span className="rm-proofbar-dot" aria-hidden="true" />
          <div>
            <small>LIVE TODAY</small>
            <strong>Cascade Condominiums</strong>
            <span>115 homes · Austin, Texas · managed by <b>a leading Austin management company</b></span>
          </div>
        </div>
        <ul className="rm-proofbar-stats">
          <li data-testid="concept-proof-stat-0"><strong>92%</strong><span>of resident requests AI can resolve or prepare <em>977-request study</em></span></li>
          <li data-testid="concept-proof-stat-1"><strong>24/7</strong><span>voice and text, on a real phone number <em>try it in the hero above</em></span></li>
          <li data-testid="concept-proof-stat-2"><strong>0</strong><span>systems to replace <em>works alongside Vantaca, CINC, Enumerate &amp; more</em></span></li>
        </ul>
      </div>
    </section>
  );
}

export function CaseStory() {
  return (
    <section id="concept-story" className="rm-story rm-section" data-testid="concept-case-story" aria-labelledby="concept-story-heading">
      <div className="rm-container">
        <div className="rm-story-grid">
          <motion.div className="rm-story-card" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5 }}>
            <p className="rm-kicker"><Radio size={12} /> CUSTOMER STORY</p>
            <h2 id="concept-story-heading">Cascade Condominiums, Austin.</h2>
            <ul className="rm-story-facts">
              <li><Building2 size={15} /> 115-home condominium</li>
              <li><MapPin size={15} /> Austin, Texas</li>
              <li><Building2 size={15} /> Managed by a leading Austin management company</li>
            </ul>
            <div className="rm-story-body" data-testid="concept-story-body">
              <p><b>Before:</b> a non-stop stream of tickets for the same questions, and residents with no way to get an answer in the moment, every "when is the pool open?" and "is my payment posted?" became a message, a wait, and a follow-up.</p>
              <p><b>With Redline:</b> residents text or call the community's concierge and get the answer right then, hours, rules, amenities, account status, from Cascade's own documents. Real requests still become tickets; the noise doesn't. The manager sees what's being asked, drafts what needs drafting, and spends the day on the work that actually needs a person.</p>
              <p><b>After:</b> a calmer inbox, a board that hears from residents less often about the basics, and a manager asking for the same setup across the rest of the portfolio.</p>
            </div>
            <a className="rm-link" href="#contact" data-testid="concept-story-cta">See it for your portfolio <ArrowUpRight size={14} /></a>
          </motion.div>
          <motion.blockquote className="rm-story-quote rm-story-quote-photo" data-testid="concept-story-quote" style={{ backgroundImage: `linear-gradient(180deg, rgba(20,17,15,0.55) 0%, rgba(20,17,15,0.82) 55%, rgba(20,17,15,0.94) 100%), url("${CASCADE_POOL}")` }} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: 0.1 }}>
            <Quote size={26} aria-hidden="true" />
            <p>“I haven't had a community run this smooth. I want this for all my properties.”</p>
            <footer><strong>Community Manager</strong><span>Cascade Condominiums · Austin, Texas</span></footer>
          </motion.blockquote>
        </div>
      </div>
    </section>
  );
}
